import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import { EditableList } from '../../../components/editable-list';
import {
  handleRequestStatusCreate,
  handleRequestStatusUpdate,
  handleRequestStatusDelete,
} from '../../../redux/thunk/organization-settings';

const enhance = compose(
  connect(null, {
    handleRequestStatusCreate, handleRequestStatusUpdate, handleRequestStatusDelete,
  }),
  withHandlers({
    onItemChange: ({ requestStatuses, ...actions }) => (editedRequestStatusId, newData) =>
      actions.handleRequestStatusUpdate(editedRequestStatusId, newData),
    onItemCreate: ({ requestStatuses, ...actions }) => newData =>
      actions.handleRequestStatusCreate(newData),
    onItemRemove: ({ requestStatuses, ...actions }) => editedRequestStatusId =>
      actions.handleRequestStatusDelete(editedRequestStatusId),
  }),
);

export const RequestStatusesList = enhance(EditableList);



// WEBPACK FOOTER //
// ./src/modals/organization-settings-modal/settings-sections/request-statuses.js